import { useEffect, useState } from 'react';
import { api } from './supabase';

export function useSettings() {
  const [settings, setSettings] = useState<Record<string, any>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await api.get<any>('/settings/index.php');
        
        // Handle the API response format: { success: true, data: [...] }
        const dataArray = response?.data || response || [];
        
        // Convert array of { key, value } to object
        const settingsMap: Record<string, any> = {};
        dataArray.forEach((item: any) => {
          try {
            // Try to parse value if it's a JSON string
            const parsedValue = typeof item.value === 'string' ? JSON.parse(item.value) : item.value;
            settingsMap[item.key] = parsedValue;
          } catch (e) {
            // If parsing fails, use the value as-is
            settingsMap[item.key] = item.value;
          }
        });
        
        console.log('Loaded settings:', settingsMap);
        setSettings(settingsMap);
      } catch (error) {
        console.error('Failed to load settings:', error);
        setSettings({});
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  return { settings, loading };
}
